(function () {
  var controllerId = "placesController";
  angular
    .module("app")
    .controller(controllerId, ["$rootScope", "$scope", "UserProvider", "$uibModalInstance", "userService", "mapService", "_", "customPlaceSetService",
      function placesController($rootScope, $scope, userProvider, $uibModalInstance, userService, mapService, _, customPlaceSetService) {
        var vm = this;
        vm.loading = false;
        vm.customPlaceSets = [];
        vm.places = [];
        vm.selectedPlacesDict = {};
        vm.display = "sets";
        vm.setName = "";
        vm.mapId = "pcmMap";
        vm.hideContent = false;

        vm.showCategories = showCategories;
        vm.showPlacesInSet = showPlacesInSet;
        vm.showPlaceOnMap = showPlaceOnMap;
        vm.getSelectedPlacesLength = getSelectedPlacesLength;

        vm.ok = ok;
        vm.close = close;
        vm.back = back;

        init();
        ////////////////
        function init () {
          vm.loading = true;
          // this will get you the list of sets for more place Modal. (Everything minus the ones already show in Favorite)
          customPlaceSetService.getCustomPlaceSets()
            .then(customPlaceSets => {
              vm.customPlaceSets = customPlaceSets;
            })
            .finally(() => {
              vm.loading = false;
            });
        }

        function showPlaceOnMap (result) {
          $rootScope.$broadcast("ShowPin", {location: result, pan: true, mapId: vm.mapId});
          vm.hideContent = true;
        }

        function showPlacesInSet ({Name, Places}) {
          vm.setName = Name;
          vm.places = Places;
          vm.hideContent = false;
          vm.display = "places";
        }

        function getSelectedPlacesLength() {
          return Object.values(vm.selectedPlacesDict).filter((v) => {
            return !!v;
          }).length;
        }


        function showCategories(set) {
          return set.Categories && set.Categories.length && set.Categories[0].Icon; // and if category belongs to one of those
        }


        function ok () {
          var Ids = [];
          _.each(vm.selectedPlacesDict, (val, key) => {
            if (val) {Ids.push(parseInt(key));}
          });
          var stops = [];
          _.each(vm.places, (p) => {
            if (_.contains(Ids, p.Id)) {
              stops.push(p);
            }
          });
          $rootScope.$broadcast("AddStop", stops);
          $uibModalInstance.close();
        }

        function close () {
          $uibModalInstance.dismiss("cancel");
          //switch to search
          $rootScope.$broadcast("FocusSearchField");
        }

        function back () {
          if (vm.hideContent === true) {
            vm.hideContent = false;
            vm.display = "places";
          } else {
            vm.display = "sets";
            vm.selectedPlacesDict = {};
          }
        }

        /////////////////////////////////////////////////////////////////
        // Event handlers section
        /////////////////////////////////////////////////////////////////

      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/places/places.controller.js